import React, { useEffect, useState } from 'react';
import { getSistemaTarifario } from '../../service/apiBackEnd.js';
import { Container, Row, Col } from 'react-bootstrap';
import styles from '../index.module.css';

const SistemaTarifario = () => {
    const [allData, setAllData] = useState([]);
    const [enrichedData, setEnrichedData] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const res = await getSistemaTarifario();
            console.log("DATA", res);
            setAllData(res);
        };
        fetchData();
    }, []);


    useEffect(() => {
        const getMediaUrl = async (mediaId) => {
            try {
                const response = await fetch(`http://epas.test.di.dgi.loc/wp-json/wp/v2/media/${mediaId}`);
                const mediaData = await response.json();
                return mediaData.source_url;
            } catch (error) {
                console.error("Error fetching media:", error);
                return null;
            }
        };

        const fetchMediaUrls = async () => {
            const updatedData = await Promise.all(
                allData.map(async (elem) => {
                    const archivoUrl = elem.acf?.adjuntar_archivo
                        ? await getMediaUrl(elem.acf?.adjuntar_archivo)
                        : null;
                    const archivoUrl2 = elem.acf?.adjuntar_archivo_2
                        ? await getMediaUrl(elem.acf?.adjuntar_archivo_2)
                        : null;

                    return { ...elem, archivoUrl, archivoUrl2 };
                })

            );
            setEnrichedData(updatedData);
        };

        if (allData.length > 0 && enrichedData.length === 0) { // Solo si aún no se han enriquecido los datos
            fetchMediaUrls();
        }
    }, [allData, enrichedData]);

    console.log("DATAAAA", allData);

    return (
        <Container>
            <Row className='mb-5'>
                <h1 className="mt-5 mb-4">Sistema de facturación</h1>
                <Col>
                    {allData.map((elem) => {
                        const textLugar = elem?.acf?.lugar ? elem.acf.lugar.replace(/<\/?[^>]+(>|$)/g, '') : '';
                        return (
                            <div className={styles.audiencia} key={elem.id}>
                                <Col lg={12}>
                                    <h4>Sistema de Facturación por Cuota Fija</h4>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: elem.acf.facturacion_por_cuota_fija,
                                        }}
                                    />
                                    <hr></hr>
                                </Col>
                                <Col lg={12}>
                                    <h4>Sistema de Facturación de Cuota Fija más Exceso</h4>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: elem.acf.facturacion_de_cuota_fija_mas_exceso,
                                        }}
                                    />
                                    <hr></hr>
                                </Col>
                                <Col lg={12}>
                                    <h4>Sistema de Facturación por Servicio Medido o Volumétrico</h4>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: elem.acf.facturacion_por_volumen,
                                        }}
                                    />
                                </Col>
                                <Col lg={12} className='mb-5 mt-5'>
                                    <h4>Importante</h4>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: elem.acf.mas_informacion
                                            ,
                                        }}
                                    />
                                </Col>
                                <h4>Tarifas Vigentes</h4>
                                <Row className={styles.bgDetalle}>

                                    <Col lg={4}>
                                        <h5>AYSAM SAPEM</h5>
                                        <label>Decreto</label>
                                        {elem.acf.adjuntar_archivo && (
                                            <a href={elem.acf.adjuntar_archivo} target="_blank" rel="noopener noreferrer" download className={styles.btnDescarga}>
                                                Ver Decreto
                                            </a>
                                        )}
                                        <label>Anexo</label>
                                        {elem.acf.adjuntar_archivo && (
                                            <a href={elem.acf.adjuntar_archivo_anexo} target="_blank" rel="noopener noreferrer" download className={styles.btnDescarga}>
                                                Ver Anexo
                                            </a>
                                        )}
                                    </Col>
                                    <Col lg={8}>
                                        <h5>OPERADORES DE SERVICIOS DE AGUA POTABLE Y CLOACA</h5>
                                        <label>Decreto</label>
                                        {elem.acf?.adjuntar_archivo_2 && (
                                            <a href={elem.acf.adjuntar_archivo_2} target="_blank" rel="noopener noreferrer" download className={styles.btnDescarga}>
                                                Ver Decreto
                                            </a>
                                        )}
                                        <label>Anexo</label>
                                        {elem.acf?.adjuntar_archivo_2 && (
                                            <a href={elem.acf.adjuntar_archivo2_anexo} target="_blank" rel="noopener noreferrer" download className={styles.btnDescarga}>
                                                Ver Anexo
                                            </a>
                                        )}
                                    </Col>
                                </Row>
                            </div>
                        );
                    })}
                </Col>
            </Row>
        </Container>
    );
};

export default SistemaTarifario;
